import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  message,
  Form,
} from 'antd';

import ModalWrapper from './ModalWrapper';
import LabelPickerTray from './LabelPickerTray';
import './addLabelModal.scss';

class AddLabelToMultipleRecords extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendTokens: props.modalType.data.record,
      receiverTypes: props.modalType.data.receiverTypes,
      labels: [],
      selectedLabels: [],
      maxAdditionalLabels: 5,
      searchValue: '',
      receivers: [],
      labelCounts: [],
      labelLimitedExceeded: false,
    };
  }

  componentDidMount = async () => {
    // eslint-disable-next-line react/destructuring-assignment
    const page = 1;
    const pageSize = 'max';
    // Surface the labels this user applies most (last 30 days) at the top.
    const sort = 'user_label_usage';
    const { getLabelsByPage } = this.props;
    await getLabelsByPage(page, pageSize, sort);
    const { data, selectedRecord } = this.props;
    let maxLabelCount = 0;
    for (let i = 0; i < selectedRecord.length; i++) {
      maxLabelCount = maxLabelCount > selectedRecord[i].labels.length ? maxLabelCount : selectedRecord[i].labels.length;
    }

    const labelCounts = new Array(selectedRecord.length).fill(0);
    for (let i = 0; i < selectedRecord.length; i++) {
      labelCounts[i] = selectedRecord[i].labels.length;
    }

    this.setState({
      labels: data,
      receivers: selectedRecord,
      maxAdditionalLabels: 5 - maxLabelCount,
      labelCounts,
    });
  }

  selectLabel = (label) => {
    const { selectedLabels, receivers, labelCounts, maxAdditionalLabels } = this.state;
    const currentlySelected = [...selectedLabels];
    const indexOfSelectedLabel = currentlySelected.findIndex(selectedLabel => selectedLabel.name === label.name);
    const labelAlreadySelected = currentlySelected.find(selectedLabel => selectedLabel.name === label.name);
    if (maxAdditionalLabels === 0) {
      this.setState({ labelLimitedExceeded: true });
      return;
    }
    let maxLabelCount = 0;
    for (let i = 0; i < receivers.length; i++) {
      if (!receivers[i].labels.some(item => item.id === label.id)) {
        labelCounts[i] += 1;
      }
      if (maxLabelCount < labelCounts[i]) {
        maxLabelCount = labelCounts[i];
      }
    }
    this.setState({ maxAdditionalLabels: 5 - maxLabelCount });
    if (!labelAlreadySelected) {
      this.setState({
        selectedLabels: [...currentlySelected, label],
      });
    } else {
      currentlySelected.splice(indexOfSelectedLabel, 1);
      this.setState({
        selectedLabels: currentlySelected,
      });
    }
  }

  deselectLabel = (label, index) => {
    const { receivers, labelCounts } = this.state;
    for (let i = 0; i < receivers.length; i++) {
      if (!receivers[i].labels.some(item => item.id === label.id)) {
        labelCounts[i] -= 1;
        this.setState({ labelLimitedExceeded: false });
      }
    }
    let maxLabelCount = 0;
    for (let i = 0; i < labelCounts.length; i++) {
      if (maxLabelCount < labelCounts[i]) {
        maxLabelCount = labelCounts[i];
      }
    }

    const { selectedLabels } = this.state;
    const currentlySelected = selectedLabels;
    currentlySelected.splice(index, 1);
    this.setState(prevState => ({
      ...prevState,
      selectedLabels: [...currentlySelected],
      receivers,
      maxAdditionalLabels: 5 - maxLabelCount,
    }));
  }

  update = async (event) => {
    event.preventDefault();
    const {
      receivers,
      sendTokens,
      selectedLabels,
      receiverTypes,
    } = this.state;

    const { editReceivedRecordLabels } = this.props;
    const selectedLabelIds = [];
    selectedLabels.map(label => selectedLabelIds.push(label.id));
    for (let i = 0; i < receivers.length; i++) {
      const uniqueLabelIds = new Set(receivers[i].labels.map(label => label.id));
      const uniqueLabelsSelected = selectedLabels.filter(label => !uniqueLabelIds.has(label.id));
      const allLabels = [...receivers[i].labels, ...uniqueLabelsSelected];
      await editReceivedRecordLabels(sendTokens[i], selectedLabelIds, allLabels, receiverTypes[i], false, null, true);
    }

    const { updatedLabel, hideModal } = this.props;
    if (updatedLabel) {
      hideModal();
      message.success({
        content: 'Labels changed',
      });
      this.updateRowSelected();
    }
  }

  renderModal = () => {
    const { isLoading, hideModal: handleHideModal } = this.props;
    const {
      labels, selectedLabels, searchValue, maxAdditionalLabels, labelLimitedExceeded,
    } = this.state;
    if (isLoading) {
      return (<span> Updating labels, Please wait... </span>);
    }

    return (
      <div className="add-label-modal">
        <LabelPickerTray
          labels={labels}
          maxAdditionalLabels={maxAdditionalLabels}
          selectedLabels={selectedLabels}
          selectedTitle="Labels to add"
          emptySelectedText="Pick labels below to add to the selected records. To remove a label, select one record at a time."
          searchValue={searchValue}
          onSearchChange={(value) => this.setState({ searchValue: value })}
          onSelectLabel={this.selectLabel}
          onDeselectLabel={this.deselectLabel}
          onDisabledLabelClick={() => this.setState({ labelLimitedExceeded: true })}
          onManageLabelsClick={handleHideModal}
          warning={labelLimitedExceeded ? 'Remove current labels from individual records to add additional labels.' : null}
        />
      </div>
    );
  }

  updateRowSelected() {
    const { selectedLabels, fileToken } = this.state;
    const { modalType, rowSelected } = this.props;
    const selectedRow = {
      labels: selectedLabels,
      file_token: fileToken,
      index: modalType.data.record.index,
    };
    rowSelected([selectedRow]);
  }

  render() {
    const { isLoading, hideModal } = this.props;
    const customContentStyle = {
      width: '460px',
    };

    return (
      <ModalWrapper
        hideModal={hideModal}
        customContentStyle={customContentStyle}
        width="460px"
        wrapClassName="add-label-modal-wrap"
        action={this.update}
        actionName="Submit"
        dismiss={isLoading ? '' : 'Cancel'}
        disabled={isLoading}
        modalTitle="Add labels to selected records"
        form="addLabelToRecord"
      >
        <Form
          layout="vertical"
          onFinish={this.update}
          id="addLabelToRecord"
        >
          {this.renderModal()}
        </Form>
      </ModalWrapper>
    );
  }
}

AddLabelToMultipleRecords.propTypes = {
  hideModal: PropTypes.func.isRequired,
  modalType: PropTypes.object.isRequired,
  rowSelected: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  updatedLabel: PropTypes.bool.isRequired,
  editReceivedRecordLabels: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  selectedRecord: PropTypes.array.isRequired,
  getLabelsByPage: PropTypes.func.isRequired,
};

export default connect(state => ({
  isLoading: state.records.isLoading,
  emailValidMessage: state.records.emailValidMessage,
  updatedLabel: state.records.updatedLabel,
  data: state.labels.data,
  selectedRecord: state.inboxTable.recordData,
}))(AddLabelToMultipleRecords);
